import * as yup from "yup";

export const emailValidationSchema = yup.object().shape({
    mail: yup.string()
        .email('Deve essere un indirizzo email')
        .required('Campo obbligatorio')
})

export const nameValidationSchema = yup.object().shape({
    name: yup.string()
        .required('Campo obbligatorio')
})

